"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionWithBudget = void 0;
var _react = _interopRequireDefault(require("react"));
var _QuestionWithRange = _interopRequireDefault(require("./QuestionWithRange"));
var _useBudgetQuestion2 = require("../../hooks/questionnaire/useBudgetQuestion");
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _constants = require("../../utils/constants");
var _QuestionWithMulti = _interopRequireDefault(require("./QuestionWithMulti"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var QuestionWithBudget = function QuestionWithBudget(_ref) {
  var question = _ref.question,
    _ref$selections = _ref.selections,
    selections = _ref$selections === void 0 ? [] : _ref$selections;
  var _useBudgetQuestion = (0, _useBudgetQuestion2.useBudgetQuestion)(question),
    isBudgetReady = _useBudgetQuestion.isBudgetReady,
    budgetQuestion = _useBudgetQuestion.budgetQuestion,
    adjustBudget = _useBudgetQuestion.adjustBudget;
  if (!isBudgetReady) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        margin: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
      size: 1,
      srText: _services.locale.localeString('Questionnaire.LoaderText')
    }));
  }
  var body = budgetQuestion.type === _constants.QUESTION_TYPE.MULTI ? /*#__PURE__*/_react.default.createElement(_QuestionWithMulti.default, {
    question: budgetQuestion,
    selections: selections,
    onUpdate: adjustBudget
  }) : /*#__PURE__*/_react.default.createElement(_QuestionWithRange.default, {
    question: budgetQuestion,
    selections: selections,
    onUpdate: adjustBudget
  });
  return body;
};
exports.QuestionWithBudget = QuestionWithBudget;